<script>
export default {
	name: 'IconSvgPng',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3719 4.10333C12.9072 4.10289 12.4617 3.92171 12.1331 3.59956C11.8045 3.2774 11.6197 2.84059 11.6192 2.385V0H3.78735C3.1807 0 2.59891 0.236264 2.16995 0.656815C1.74099 1.07736 1.5 1.64775 1.5 2.2425V15.7608C1.5009 16.355 1.74229 16.9245 2.17115 17.3444C2.60001 17.7642 3.18129 18 3.78735 18H13.1892C13.7954 18 14.3768 17.7641 14.8057 17.3441C15.2346 16.9241 15.4759 16.3543 15.4765 15.76V4.10333H13.3719Z"
				:fill="color" />
			<path
				d="M15.4764 4.10333H13.3718C12.9071 4.10289 12.4616 3.92171 12.133 3.59956C11.8044 3.2774 11.6196 2.84059 11.6191 2.385V0L15.4764 4.10333Z"
				fill="#0055A3" />
			<path
				d="M17.1349 14.2166H6.50646C5.75253 14.2166 5.14136 14.8157 5.14136 15.5549V18.6615C5.14136 19.4007 5.75253 19.9999 6.50646 19.9999H17.1349C17.8888 19.9999 18.5 19.4007 18.5 18.6615V15.5549C18.5 14.8157 17.8888 14.2166 17.1349 14.2166Z"
				fill="#0055A3" />
			<path d="M8.22013 17.7809V18.3867H7.58008V17.7809H8.22013Z" fill="#F3F3F6" />
			<path
				d="M9.16018 17.5084V18.3867H8.54138V15.8809H9.54268C9.84698 15.8809 10.0785 15.9547 10.2371 16.1025C10.3177 16.18 10.3806 16.2732 10.4218 16.3762C10.4629 16.4792 10.4814 16.5896 10.476 16.7C10.4787 16.8458 10.4417 16.9896 10.3689 17.1167C10.2951 17.2411 10.1849 17.3409 10.0527 17.4034C9.89365 17.4777 9.71879 17.5137 9.54268 17.5084H9.16018ZM9.84699 16.7C9.84699 16.4778 9.72289 16.3667 9.47469 16.3667H9.16018V17.0192H9.47469C9.72289 17.0214 9.84699 16.915 9.84699 16.7Z"
				fill="#F3F3F6" />
			<path
				d="M13.0498 18.3867H12.4318L11.3965 16.8484V18.3867H10.7786V15.8809H11.3965L12.431 17.4334V15.8809H13.0489L13.0498 18.3867Z"
				fill="#F3F3F6" />
			<path
				d="M15.4645 16.0833C15.6708 16.2346 15.8093 16.4583 15.8512 16.7075H15.1967C15.1538 16.6182 15.0849 16.5434 14.9987 16.4925C14.9013 16.4358 14.7897 16.407 14.6765 16.4091C14.5886 16.4056 14.5009 16.4209 14.4197 16.4542C14.3385 16.4875 14.2657 16.5378 14.2065 16.6016C14.0823 16.7479 14.0192 16.9349 14.0297 17.125C14.0297 17.3633 14.0917 17.5464 14.2158 17.6741C14.2856 17.7405 14.3687 17.7919 14.4599 17.8249C14.5511 17.8579 14.6484 17.8718 14.7454 17.8658C14.8841 17.8681 15.0198 17.8263 15.1321 17.7466C15.2466 17.6626 15.3292 17.5435 15.3667 17.4083H14.5864V16.9725H15.8844V17.5833C15.8341 17.7323 15.7554 17.8706 15.6523 17.9908C15.5411 18.1201 15.4024 18.2242 15.246 18.2958C15.0687 18.376 14.8752 18.4159 14.6799 18.4125C14.4427 18.4183 14.2081 18.3626 13.9999 18.2508C13.8095 18.1461 13.6544 17.9891 13.5537 17.7991C13.446 17.5945 13.3919 17.3668 13.3964 17.1366C13.3913 16.905 13.4454 16.6759 13.5537 16.47C13.6542 16.2804 13.8086 16.1236 13.9982 16.0183C14.2034 15.9075 14.4348 15.852 14.6689 15.8575C14.9523 15.8438 15.2323 15.9233 15.4645 16.0833Z"
				fill="#F3F3F6" />
			<path d="M6.14946 5.56006H4.98071V6.70589H6.14946V5.56006Z" fill="#0055A3" />
			<path d="M7.31914 6.70581H6.15039V7.85164H7.31914V6.70581Z" fill="#0055A3" />
			<path d="M8.48784 5.56006H7.31909V6.70589H8.48784V5.56006Z" fill="#0055A3" />
			<path d="M9.65655 6.70581H8.48779V7.85164H9.65655V6.70581Z" fill="#0055A3" />
			<path d="M10.827 5.56006H9.6582V6.70589H10.827V5.56006Z" fill="#0055A3" />
			<path d="M11.9958 6.70581H10.827V7.85164H11.9958V6.70581Z" fill="#0055A3" />
			<path d="M6.14946 7.8501H4.98071V8.99593H6.14946V7.8501Z" fill="#0055A3" />
			<path d="M7.31914 8.99585H6.15039V10.1417H7.31914V8.99585Z" fill="#0055A3" />
			<path d="M8.48784 7.8501H7.31909V8.99593H8.48784V7.8501Z" fill="#0055A3" />
			<path d="M9.65655 8.99585H8.48779V10.1417H9.65655V8.99585Z" fill="#0055A3" />
			<path d="M10.827 7.8501H9.6582V8.99593H10.827V7.8501Z" fill="#0055A3" />
			<path d="M11.9958 8.99585H10.827V10.1417H11.9958V8.99585Z" fill="#0055A3" />
			<path d="M6.14946 10.1509H4.98071V11.2967H6.14946V10.1509Z" fill="#0055A3" />
			<path d="M7.31914 11.2966H6.15039V12.4425H7.31914V11.2966Z" fill="#0055A3" />
			<path d="M8.48784 10.1509H7.31909V11.2967H8.48784V10.1509Z" fill="#0055A3" />
			<path d="M9.65655 11.2966H8.48779V12.4425H9.65655V11.2966Z" fill="#0055A3" />
			<path d="M10.827 10.1509H9.6582V11.2967H10.827V10.1509Z" fill="#0055A3" />
			<path d="M11.9958 11.2966H10.827V12.4425H11.9958V11.2966Z" fill="#0055A3" />
		</svg>

	</div>
</template>

<style scoped>

</style>